import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { KycDialogComponent } from 'src/app/shared/components/kyc-dialog/kyc-dialog.component';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { Verify2FAComponent } from 'src/app/shared/components/verify-2fa/verify-2fa.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { DialogType, LoginService } from './login.service';
import { RegisterAgreeComponent } from './register-agree/register-agree.component';
import { ResetPasswordEmailComponent } from './reset-password-email/reset-password-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ThirdPartyComponent } from './third-party/third-party.component';
@Component({
  standalone: true,
  selector: 'login-dialog',
  templateUrl: './login-dialog.html',
  styleUrls: ['./login-dialog.scss'],
  imports: [
    CommonModule,
    LoginRegisterComponent,
    RegisterAgreeComponent,
    ResetPasswordComponent,
    Verify2FAComponent,
    ResetPasswordEmailComponent,
    ThirdPartyComponent,
    KycDialogComponent,
  ],
})
export class LoginDialogComponent implements OnInit {
  constructor(
    public loginService: LoginService,
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    public appService: AppService,
    private localStorageService: LocalStorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tabIndex: 0;
    },
  ) {
    this.dialogRef.afterClosed().subscribe(() => {
      this.loginService.reset();
      if (!this.localStorageService.loginToken) {
        this.localStorageService.pendingLoginRedirectUrl = '';
      }

      //移除URL中的popup参数
      void this.appService.removeDialogParam();
    });
    this.tabIndex = data.tabIndex;
  }

  public ngOnInit() {
    void this.loginService.refreshNeedKycFlag();
  }

  public tabIndex = 0;

  public type$ = this.loginService.dialogType$;

  public dialogType = DialogType;

  public kycLoading = false;

  public registerAgree() {
    this.loginService.confirmRegisterAgreement();
  }

  public async onKycSubmit(formValue: any) {
    if (this.kycLoading) {
      return;
    }
    this.kycLoading = true;
    try {
      const email = this.loginService.email || formValue.email;
      await this.loginService.submitKycForm({
        countryCode: formValue.country,
        fullName: `${formValue.name} ${formValue.surname}`,
        firstName: formValue.name,
        lastName: formValue.surname,
        dob: formValue.dateOfBirth,
        address: formValue.street,
        city: formValue.city,
        zipCode: formValue.postcode,
        email,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.kycLoading = false;
    }
  }

  public onKycClose() {
    this.dialogRef.close();
  }
}
